import React from 'react';

interface PowerBIIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const PowerBIIcon: React.FC<PowerBIIconProps> = ({
  width = 24,
  height = 24,
  color = '#F2C811',
  className
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
      style={{ display: 'inline-block' }}
    >
      {/* Power BI logo - chart bars and analytics */}
      <rect x="3" y="14" width="3" height="6" fill={color} rx="1" />
      <rect x="7" y="10" width="3" height="10" fill={color} rx="1" />
      <rect x="11" y="6" width="3" height="14" fill={color} rx="1" />
      <rect x="15" y="8" width="3" height="12" fill={color} rx="1" />
      <rect x="19" y="12" width="3" height="8" fill={color} rx="1" />
      <circle cx="4.5" cy="4" r="1.5" fill={color} opacity="0.7" />
      <circle cx="8.5" cy="5" r="1" fill={color} opacity="0.7" />
      <circle cx="12.5" cy="3" r="1" fill={color} opacity="0.7" />
      <circle cx="16.5" cy="4" r="1" fill={color} opacity="0.7" />
      <circle cx="20.5" cy="6" r="1" fill={color} opacity="0.7" />
    </svg>
  );
};
